<template>
    <flex-element :element-type="elementType" tag="ul" class-default-inline="f-flex f-justify-start f-flex-auto f-flex-col f-w-1/1">
        <drawer
            v-for="(element, index) in elementsNew"
            :key="element.id"
            :index="index"
            :display-name="titleCase(element.elementType)"
            v-bind="element"
            :pointer="index + 1"
            :icon-collapsed="iconCollapsed"
            :icon-expanded="iconExpanded"
            :expanded-drawer-index="expandedDrawerIndex"
            :close-other-drawers="closeOtherDrawers"
            :is-dynamic-element="true"
            @expanded="onExpand"
            @element-updated="elementUpdated"
            @delete-element="deleteElement"
        />

        <droppable
            force-display
            mode="click"
            text="Click to add a drawer"
            element-type="droppable"
            @click.native.stop="onAddDrawerClick"
        />
    </flex-element>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import uuidv4 from 'uuid/v4';

import { CLEAR_SELECTED_ELEMENT } from '@/store/types/mutation-types';
import baseOrganism from '@/mixins/base-organism/base-organism-smart';
import flexDeepCopy from '@/utils/flex-deep-copy';
import { Organism } from '@/data/data-models';
import mapFilters from '@/utils/map-filters';

export default {
    mixins: [baseOrganism],

    props: {
        displayName: {
            default: 'Drawer Collection',
            type: String,
        },
    },

    data() {
        return {
            expandedDrawerIndex: -1,
            height: 0,
            isDrawerBodyVisible: false,

            iconImgCollapsed: '',
            iconImgExpanded: '',
        };
    },

    computed: {
        ...mapState({
            selectedElements: state => state.page.selectedElements,
        }),

        iconExpanded() {
            return this.hasElementData('drawer-icon-expanded') ? this.getElementData('drawer-icon-expanded') : 'chevron-up';
        },

        iconCollapsed() {
            return this.hasElementData('drawer-icon-collapsed') ? this.getElementData('drawer-icon-collapsed') : 'chevron-down';
        },

        closeOtherDrawers() {
            return this.getElementData('drawer-expand') === 'close-other-drawers';
        },
    },

    methods: {
        ...mapFilters(['titleCase']),

        ...mapMutations({
            clearSelectedElement: CLEAR_SELECTED_ELEMENT,
        }),

        deleteElement(index) {
            this.elementsNew.splice(index, 1);
            this.clearSelectedElement(index);
            this.setChangedData(true);
        },

        onAddDrawerClick() {
            // until drop zone index changes, we go by length
            const pointer = this.elementsNew.length + 1;

            let element = null;

            if (this.elementsNew.length) {
                element = { ...this.elementsNew[this.elementsNew.length - 1] };

                element.id = uuidv4();
                element = flexDeepCopy(element);
            } else {
                element = new Organism({
                    id: uuidv4(),
                    name: `drawer_${ pointer }`,
                    elementType: 'drawer',
                    pointer,
                    classes: '',
                    templateType: 'Organism',
                    dataSourceId: '00000000-0000-0000-0000-000000000000',
                });
            }

            this.elementsNew.push(element);
            this.setChangedData(true);
        },

        onExpand(drawerIndex) {
            this.expandedDrawerIndex = drawerIndex;
        },
    },
};
</script>
